import { 
    LOGIN_RESULT, 
    NUM_PLAYERS_CHANGED, 
    NUM_IMPROVISERS_CHANGED, 
    UNKNOWN_TOKEN,
    PLAYER_ADDED,
    PLAYER_REMOVED,
    LOGGED_OUT,
    USER_LOGGED_IN,
    USER_LOGGED_OUT,
    USER_DELETED,
    
    ALL_USER_DELETED,
    DICE_LAUNCHED,
    RESULT_RESETTED,
    QUESTION_LAUNCHED,
    PLAYER_SELECTED,
    PLAYER_TWO_SELECTED,
    PLAYER_RESETTED,
    RESULT_SENT,
    TWO_WORDS_LAUNCHED,
    VOTATION_LAUNCHED,
    VOTATION_AMAGGIORANZA_LAUNCHED,
    VOTE_RECEIVED,
    VOTE_AMAGGIORANZA_RECEIVED,
    SONG_LAUNCHED,
    CHOICE_LAUNCHED,
    CHOICE_RECEIVED,
    NO_MORE_SONG,
    NO_MORE_QUESTION,
    NO_MORE_TWO_WORDS,
    NO_MORE_SEVEN_WORDS,
    DATABASE_CHECKED,
    DB_INITIATED,
    SEVEN_WORDS_LAUNCHED,
    IMPROVISER_ADDED,
    IMPROVISER_REMOVED,
    GAME_ENDED,
    I_VE_END
} from '../events/ServerToClient'

import { 
    loginResult, 
    numPlayersChanged, 
    numImprovisersChanged, 
    userLoggedIn,
    userLoggedOut,
    playerAdded,
    playerRemoved,
    allUserDeleted,
    diceLaunched,
    questionLaunched,
    playerSelected,
    playerTwoSelected,
    playerResetted,
    resultSent,
    resultResetted,
    twoWordsLaunched,
    sevenWordsLaunched,
    votationLaunched,
    votationAMaggioranzaLaunched,
    voteReceived,
    voteAMaggioranzaReceived,
    songLaunched,
    choiceLaunched,
    choiceReceived,
    noMoreSong,
    noMoreQuestions,
    noMoreTwoWords,
    noMoreSevenWords,
    databaseChecked,
    databaseInitiated,
    improviserAdded,
    improviserRemoved,
    gameEnded,
    iVeEnd
} from '../reducers/actions'

import {loggedOut, userDeleted } from '../reducers/user/actions'
import { socketConnected, socketDisconnected } from '../reducers/connected'
import  { RECONNECT } from '../events/ClientToServer'

export default (    store) => {
    const { socket } = store.getState()

    socket.on('connect', () => {
        store.dispatch(socketConnected())
        const { currentToken } = store.getState()
        if (currentToken)
            socket.emit(RECONNECT, { token: currentToken })
    })
    socket.on('disconnect', () => store.dispatch(socketDisconnected()))

    socket.on(LOGIN_RESULT, (user) => store.dispatch(loginResult(user)))
    socket.on(UNKNOWN_TOKEN, () => window.location.reload())
    socket.on(PLAYER_ADDED,({user_id}) => store.dispatch(playerAdded(user_id)))
    socket.on(PLAYER_REMOVED,({user_id}) => store.dispatch(playerRemoved(user_id)))
    socket.on(LOGGED_OUT,(user)=> store.dispatch(loggedOut(user)))
    socket.on(USER_LOGGED_IN,(user)=> store.dispatch(userLoggedIn(user)))
    socket.on(USER_LOGGED_OUT,(user)=> store.dispatch(userLoggedOut(user)))
    socket.on(USER_DELETED,({user_id})=> store.dispatch(userDeleted(user_id)))
    socket.on(IMPROVISER_ADDED,(id) => store.dispatch(improviserAdded(id)))
    socket.on(IMPROVISER_REMOVED,(id) => store.dispatch(improviserRemoved(id)))
    socket.on(QUESTION_LAUNCHED,(question) => store.dispatch(questionLaunched(question)))
    socket.on(SONG_LAUNCHED,(song) => store.dispatch(songLaunched(song)))
    socket.on(VOTATION_LAUNCHED,() => store.dispatch(votationLaunched()))
    socket.on(VOTATION_AMAGGIORANZA_LAUNCHED,() => store.dispatch(votationAMaggioranzaLaunched()))
    socket.on(CHOICE_LAUNCHED,() => store.dispatch(choiceLaunched()))
    socket.on(TWO_WORDS_LAUNCHED,(twoWords, playerNumber) => store.dispatch(twoWordsLaunched(twoWords,playerNumber)))
    socket.on(SEVEN_WORDS_LAUNCHED,({sevenWords,number}) => store.dispatch(sevenWordsLaunched(sevenWords,number)))
    socket.on(DICE_LAUNCHED,() => store.dispatch(diceLaunched()))
    socket.on(RESULT_RESETTED,() => store.dispatch(resultResetted()))
    socket.on(RESULT_SENT,({result}) => store.dispatch(resultSent(result)))
    socket.on(VOTE_RECEIVED,({vote}) => store.dispatch(voteReceived(vote)))
    socket.on(VOTE_AMAGGIORANZA_RECEIVED,({vote}) => store.dispatch(voteAMaggioranzaReceived(vote)))
    socket.on(CHOICE_RECEIVED,({choice}) => store.dispatch(choiceReceived(choice)))
    socket.on(PLAYER_SELECTED, ({username}) => store.dispatch(playerSelected({username})))
    socket.on(PLAYER_TWO_SELECTED, ({username}) => store.dispatch(playerTwoSelected({username})))
    socket.on(PLAYER_RESETTED, () => store.dispatch(playerResetted()))
    socket.on(NUM_PLAYERS_CHANGED, ({numPlayers }) => store.dispatch(numPlayersChanged({numPlayers })))
    socket.on(NUM_IMPROVISERS_CHANGED, ({numImprovisers }) => store.dispatch(numImprovisersChanged({numImprovisers })))
    socket.on(NO_MORE_QUESTION,() => store.dispatch(noMoreQuestions()));
    socket.on(NO_MORE_TWO_WORDS,() => store.dispatch(noMoreTwoWords()));
    socket.on(NO_MORE_SEVEN_WORDS,() => store.dispatch(noMoreSevenWords()));
    socket.on(NO_MORE_SONG,() => store.dispatch(noMoreSong()));
    socket.on(ALL_USER_DELETED,() => store.dispatch(allUserDeleted()))
    socket.on(DATABASE_CHECKED,({result}) => store.dispatch(databaseChecked(result)))
    socket.on(DB_INITIATED,({result}) => store.dispatch(databaseInitiated(result)))
    socket.on(GAME_ENDED,() => store.dispatch(gameEnded())),
    socket.on(I_VE_END, () =>store.dispatch(iVeEnd()))

}
     


// WEBPACK FOOTER //
// ./src/listeners/socket.js